import { Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { of } from 'rxjs';
import en from '../i18n/en';
import da from '../i18n/da';
import sv from '../i18n/sv';
import no from '../i18n/no';
import es from '../i18n/es';

/**
 * A utility class that implements the `TranslocoLoader` interface for managing translations.
 * This class provides functionality to retrieve translations based on a given language code.
 *
 * It utilizes a predefined map of translations and leverages the `@Injectable` decorator to make it injectable
 * as a service within Angular's DI system.
 *
 * Features:
 * - Maintains a private, readonly translation mapping for supported languages.
 * - Fetches translations for a specific language passed as a parameter.
 *
 * Dependencies:
 * - The `of` operator is used to return translations as an observable.
 *
 * Implements:
 * - `TranslocoLoader` interface.
 */
@Injectable({ providedIn: 'root' })
export class TransLocoHttpLoaderUtilityClass implements TranslocoLoader {
  readonly #translationMap: Record<string, Translation> = {
    en,
    da,
    sv,
    no,
    es,
  };

  getTranslation(lang: string) {
    return of(this.#translationMap[lang]);
  }
}
